import { ApiPath } from "enums";
import { Get, Post, Put, Delete } from "utils";

export const generateReport = async (query) => {
  const res = await Post(`${ApiPath.GenerateReport}`, query);
  return res.data;
};

export const generatePricingReport = async (query) => {
  const res = await Post(`${ApiPath.GeneratePricingReport}`, query);
  return res.data;
};

export const generatePricingAdminReport = async (query) => {
  const res = await Post(`${ApiPath.GeneratePricingAdminReport}`, query);
  return res.data;
};

export const generatePricingReportv2 = async (query) => {
  const res = await Post(`${ApiPath.GeneratePricingReportv2}`, {
    ...query,
    connectionId: query.sessionId,
  });
  return res.data;
};

export const generateReportAdmin = async (query) => {
  const res = await Post(`${ApiPath.GenerateReportAdmin}`, {
    ...query,
    connectionId: query.sessionId,
  });
  return res.data;
};

export const generateReportAdminLoyalty = async ({ sessionId, ...query }) => {
  const res = await Post(`${ApiPath.GenerateReportAdminLoyalty}`, {
    ...query,
    connectionId: sessionId,
  });
  return res.data;
};

export const generateBookingReportAdmin = async (query) => {
  const res = await Post(`${ApiPath.GenerateBookingReportAdmin}`, {
    ...query,
    connectionId: query.sessionId,
  });
  return res.data;
};

export const generateProfileAdmin = async (query) => {
  const res = await Post(`${ApiPath.GenerateProfileAdmin}`, {
    ...query,
    connectionId: query.sessionId,
  });
  return res.data;
};

export const generateReportList = async (query) => {
  const res = await Get(`${ApiPath.GenerateReportList}`, query);
  return res.data;
};

export const updateReport = async ({ reportId, ...body }) => {
  const res = await Put(`${ApiPath.UpdateReport(reportId)}`, body);
  return res.data;
};

export const deleteReport = async ({ reportId }) => {
  const res = await Delete(`${ApiPath.UpdateReport(reportId)}`);
  return res;
};
